module.exports = __webpack_public_path__ + "img/no-avatar.fdd1f37e.svg";